import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
  OAuthProvider,
  signOut as firebaseSignOut,
} from 'firebase/auth';
import { Gender } from '../enums/gender';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

export const signOut = async () => {
  await firebaseSignOut(auth);
};

export const signUpWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential?.idToken;
    const user = result.user;
    const userData = {
      firstName: user.displayName?.split(' ')[0] || '',
      lastName: user.displayName?.split(' ').slice(1).join(' ') || '',
      email: user.email,
      imageUrl: user.photoURL,
    };

    return { userData: userData, token: token };
  } catch (error) {
    console.error('Google sign up error:', error);
    throw error;
  }
};

// Facebook ile kayıt ol
export const signUpWithFacebook = async () => {
  try {
    const result = await signInWithPopup(auth, facebookProvider);
    const user = result.user;

    const credential = FacebookAuthProvider.credentialFromResult(result);
    const accessToken = credential.accessToken;

    const response = await fetch(
      `https://graph.facebook.com/me?fields=first_name,middle_name,last_name,email,picture,gender,link,website&access_token=${accessToken}`,
    );
    const data = await response.json();

    const userData = {
      firstName: data.first_name || '',
      middleName: data.middle_name || '',
      lastName: data.last_name || '',
      email: data.email || user.email,
      imageUrl: data.picture?.data?.url || user.photoURL,
      gender: data.gender != '' && data.gender == 'female' ? Gender.Female : Gender.Male,
      facebook: data.link || '',
      website: data.website || '',
    };

    return { userData: userData, token: accessToken };
  } catch (error) {
    console.error('Facebook sign up error:', error);
    throw error;
  }
};

// Facebook ile giriş yap
export const signInWithFacebook = async () => {
  try {
    const result = await signInWithPopup(auth, facebookProvider);
    const user = result.user;

    // Facebook'tan gelen token bilgisini al
    const credential = FacebookAuthProvider.credentialFromResult(result);

    return {
      user,
      token: credential.accessToken,
    };
  } catch (error) {
    console.error('Facebook sign in error:', error);
    throw error;
  }
};

// Facebook provider'ına scope'lar ekle
facebookProvider.addScope('email');
facebookProvider.addScope('public_profile');
